<template>
  <div class="login-page">
    <form @submit.prevent="handleLogin" class="glass-card form-shell">
      <h2>Login</h2>

      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input type="email" id="email" v-model="email" required placeholder="Email" class="input-field" />
      </div>

      <div class="form-group">
        <label class="form-label" for="password">Password</label>
        <input type="password" id="password" v-model="password" required placeholder="Password" class="input-field" />
      </div>

      <button type="submit" class="pill-button accent btn-wide" :disabled="isLoading">
        {{ isLoading ? "Logging in..." : "Login" }}
      </button>

      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </form>

    <!-- Spinner overlay while loading -->
    <Spinner :show="isLoading" />
  </div>
</template>

<script>
import axios from "axios";
import auth from "@/services/auth";
import Spinner from "@/components/SpinnerComponent.vue";
import { fetchChatbots } from "@/services/fetchChatbotService"; // Import the service

export default {
  name: "LoginPage",
  components: {
    Spinner,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_MICROSERVICE_API_URL,
      email: "",
      password: "",
      errorMessage: "",
      isLoading: false,
      chatbots: [],
      userId: null,
    };
  },
  methods: {
    async handleLogin() {
      this.errorMessage = "";
      if (!this.email || !this.password) {
        this.errorMessage = "Please provide both email and password.";
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.post(`${this.apiUrl}/users/login`, {
          email: this.email,
          password: this.password,
        });

        const customerRecord = response.data;
        auth.login();
        localStorage.setItem("userId", customerRecord.id);
        localStorage.setItem("customerRecord", JSON.stringify(customerRecord));
        this.userId = customerRecord.id;
        this.$router.push("/admin");

        // Fetch chatbots after login using the service
        this.chatbots = await fetchChatbots(this.userId);
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "Invalid email or password.....";
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    console.log("Login API URL: " + this.apiUrl);
    this.userId = localStorage.getItem("userId");
    if (!this.userId) {
      // alert('User ID is missing. Please log in again.');
      this.$router.push('/login');
    } else {
      // Fetch chatbots during mounting if needed
      this.chatbots = await fetchChatbots(this.userId);
    }
  },
};
</script>


<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 16px;
}

.form-shell {
  max-width: 480px;
  width: 100%;
  padding: 28px;
  display: grid;
  gap: 14px;
}

h2 {
  font-size: 2rem;
  margin: 0 0 4px;
  color: var(--text-primary);
  text-align: center;
}

.btn-wide {
  width: 100%;
  justify-content: center;
}

.error-message {
  color: var(--error);
  margin-top: 0.5rem;
  text-align: center;
}
</style>
